import { useReducer, useState } from 'react';

export default function useEmailValidation() {
  const validateEmail = email => {
    const re = /^([-!#-'*+\/-9=?A-Z^-~]{0,64}(\.[-!#-'*+\/-9=?A-Z^-~]+)*|"\s([]!#-[^-~ \t]|(\\[\t -~]))+")@[0-9A-Za-z]([0-9A-Za-z-]{0,255}[0-9A-Za-z])?(\.[0-9A-Za-z]([0-9A-Za-z-]{0,61}[0-9A-Za-z])?)$/;
    return re.test(String(email).toLowerCase());
  };
  const [emailValid, setEmailValid] = useState(false);
  const emailReducer = (state, action) => {
    const isValidEmail = validateEmail(action);
    setEmailValid(isValidEmail);
    return action;
  };

  const [email, setEmail] = useReducer(emailReducer, '');
  const retObject = { setEmail, email, emailValid };
  return retObject;
}
